import React from "react";
import Lottie from "react-lottie";

import * as animationData from "../../../animations/locked-animation.json";

const LookLockedOverlayAnimatedIcon = () => {

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Lottie options={defaultOptions} />
  )
};

export default LookLockedOverlayAnimatedIcon
